export default {
    meetings: state => state.meetings,
    totalMeetings: state => state.totalMeetings,
    getMeetingsActionsCount: state => state.meetingsActionsCount
};